import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { isAdmin } from '@/lib/types';
import { Icon } from '@/ui';

interface Item { to: string; label: string; icon: string; adminOnly?: boolean; end?: boolean; }
const ITEMS: Item[] = [
  { to: '/admin', label: 'Dashboard', icon: 'layout-dashboard', end: true },
  { to: '/admin/blog', label: 'Blog', icon: 'newspaper' },
  { to: '/admin/categories', label: 'Kategorien', icon: 'tags' },
  { to: '/admin/users', label: 'Benutzer', icon: 'users', adminOnly: true },
  { to: '/admin/settings', label: 'Einstellungen', icon: 'settings', adminOnly: true },
];

export function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const admin = isAdmin(user);
  const items = ITEMS.filter((i) => !i.adminOnly || admin);

  const doLogout = () => { logout(); navigate('/admin/login', { replace: true }); };

  return (
    <div className="ar-admin" style={{ display: 'flex', minHeight: '100vh', background: 'var(--surface-page)' }}>
      <aside style={{ width: 236, flex: 'none', borderRight: '1px solid var(--border-subtle)', background: 'var(--surface-card)', display: 'flex', flexDirection: 'column', position: 'sticky', top: 0, height: '100vh' }}>
        <div style={{ padding: '20px 20px 16px', borderBottom: '1px solid var(--border-subtle)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
            <span style={{ display: 'inline-flex', color: 'var(--primary-200)' }}><Icon name="shield" size={20} /></span>
            <span style={{ fontWeight: 800, fontSize: 16, color: 'var(--text-100)', letterSpacing: '-0.02em' }}>Aria Admin</span>
          </div>
        </div>
        <nav style={{ padding: 12, display: 'flex', flexDirection: 'column', gap: 3, flex: 1 }}>
          {items.map((i) => (
            <NavLink
              key={i.to}
              to={i.to}
              end={i.end}
              style={({ isActive }) => ({
                display: 'flex', alignItems: 'center', gap: 11, padding: '10px 12px', borderRadius: 'var(--radius-sm)',
                fontSize: 14.5, fontWeight: isActive ? 600 : 500, textDecoration: 'none',
                color: isActive ? 'var(--primary-200)' : 'var(--text-200)',
                background: isActive ? 'rgba(74,144,226,0.12)' : 'transparent',
              })}
            >
              <Icon name={i.icon} size={18} /> {i.label}
            </NavLink>
          ))}
        </nav>
        <div style={{ padding: 16, borderTop: '1px solid var(--border-subtle)' }}>
          <div style={{ fontSize: 13, color: 'var(--text-100)', fontWeight: 600 }}>{user?.name || user?.email}</div>
          <div style={{ fontSize: 12, color: 'var(--text-200)', marginBottom: 12, textTransform: 'capitalize' }}>{user?.role}</div>
          <button onClick={doLogout} style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%', justifyContent: 'center', padding: '9px 12px', borderRadius: 'var(--radius-sm)', border: '1px solid var(--border-default)', background: 'var(--surface-page)', color: 'var(--text-100)', fontSize: 13.5, cursor: 'pointer', fontFamily: 'var(--font-sans)' }}>
            <Icon name="log-out" size={16} /> Abmelden
          </button>
        </div>
      </aside>

      <main style={{ flex: 1, minWidth: 0, padding: '32px 36px', maxWidth: 1100 }}>
        <Outlet />
      </main>
    </div>
  );
}
